module.exports = __webpack_public_path__ + "static/media/texture (43).ee2c3341.jpg";